import { render, staticRenderFns } from "./PriceDetails.vue?vue&type=template&id=bb624d98"
import script from "./PriceDetails.vue?vue&type=script&lang=js"
export * from "./PriceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports